/** Shopify CDN: Minification failed

Line 46:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 47:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 47:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 48:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 48:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 50:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 52:54 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 60:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 68:30 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 74:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 3 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 31:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 32:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 32:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 33:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 33:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 35:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 37:54 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 45:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 53:30 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 59:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 3 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 16:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 17:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 17:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 18:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 18:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 20:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 22:54 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 30:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 38:30 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 44:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 3 more hidden warnings

**/
(async () => {
    const { Core } = await importModule('Core');
    const { $toggleDisplay } = await importModule('Utils');

    const CN_DISABLED = '!disabled';

    customElements.define('product-dynamic-checkout', class extends Core {
        subscriptions = {
            'buyWith:change':  '_handleBuyWith',
            'cart:add':  '_disable',
            'cart:update':  '_enable',
            'cart:error':  '_enable'
        }

        render() {
            this._rerenderPaymentButton();
            this.subscribe('buyWith:change');
            this.subscribe('cart:add', { global: true });
            this.subscribe('cart:update', { global: true });
            this.subscribe('cart:error', { global: true });
        }

        _rerenderPaymentButton() {
            if (window.Shopify?.PaymentButton?.init) {
              window.Shopify.PaymentButton.init();
            }
        };

        _handleBuyWith({ selected }) {
            return $toggleDisplay(this, !selected);
        }

        _disable() {
            this.disabled = true;
        }

        _enable() {
            setTimeout(() => {
                this.disabled = false
            }, 1500);
        };

        set disabled(state) {
            this.classList.toggle(CN_DISABLED, state);
        };
    })
})();